import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListSubscription(authorization,filter) {
  const url = `${API_URL}/admin/subscription`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListVerifyStudent(authorization,filter) {
  const url = `${API_URL}/admin/subscription/verify`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListVerifyStudentHistory(authorization,filter) {
  const url = `${API_URL}/admin/subscription/verify-history`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getSubscriptionHistory(authorization, filter) {
  const url = `${API_URL}/webclient/account/subscription-history`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  })
    .then(response => response.data)
    .catch((err) => {
      throw err.response;
    });
}

export async function getSubscriptionReceipt(authorization, id) {
  const url = `${API_URL}/webclient/account/subscription-receipt/${id}`;
  return axios({
    url,
    method: 'get',
    responseType: 'blob',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    },
  })
    .then(response => response)
    .catch((err) => {
      throw err.response;
    });
}



// WEBPACK FOOTER //
// ./src/services/subscription.js